export default "__VITE_ASSET__DdvM_1tP__"